import React from 'react';
import Styles from "../../styles.module.scss";
import Button from '../../../../components/button';
import Headline5 from "../../../../components/headings/Headline5";


function Assessments() {


    return (
        <div className={Styles.workSurvay}>
            <Headline5>Tell us about your work experience</Headline5>
            <p>You will be requested to furnish the past work experience so that we can know you better to get matched to the relevant job opportunities…</p>
            <Button onClick={[]} variant="primary" size='medium'>Start Survey</Button>
            <div className={Styles.time}>40 mintues</div>
        </div>
        );
    }
    export default Assessments